import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SideMenu } from 'react-sidemenu';
import 'react-sidemenu/dist/react-sidemenu.min.css';
import pubsub from 'pubsub-js';
import { Collapse } from 'react-bootstrap';

import SidebarRun from './sidebar.run';
import defaultUserAvatar from '../../../assets/img/user/defaultAvatar.jpg';
import { updateSidebarSelectedItem } from '../../../services/redux/employee/sidebar/actions';

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userBlockCollapse: true,
            searchTerm: '',
            activeItem: ''
        };

        this.pubsub_token = pubsub.subscribe('toggleUserblock', () => {
            this.setState({
                userBlockCollapse: !this.state.userBlockCollapse
            });
        });

        this.pubsub_token = pubsub.subscribe('refreshSideMenu', () => {
            //trigger a re-render of the sidemenu
            this.setState(currentState => {
                return { activeItem: currentState.activeItem };
            });
        });

        this.navigator = this.navigator.bind(this);
    }

    navigator(route) {
        let { history } = this.props;
        history.push(route);
    }

    componentDidMount() {
        // pass navigator to access router api
        SidebarRun(this.navigator);
    }

    componentWillUnmount() {
        // React removed me from the DOM, I have to unsubscribe from the pubsub using my token
        pubsub.unsubscribe(this.pubsub_token);
    }

    componentWillReceiveProps(nextProps, nextState) {
        this.setState({ activeItem: nextProps.sidebar.activeItem });
    }

    render() {
        let { userBlockCollapse, activeItem } = this.state;
        let { history, items, user, updateSidebarSelectedItem } = this.props;
        return (
            <aside className="aside">
                {/* START Sidebar (left) */}
                <div className="aside-inner">
                    <nav data-sidebar-anyclick-close="" className="sidebar">
                        {/* START sidebar nav */}
                        <ul className="nav">
                            {/* START user info */}
                            <li className="has-user-block">
                                <Collapse
                                    id="user-block"
                                    in={userBlockCollapse}
                                >
                                    <div>
                                        {user && (
                                            <div className="item user-block">
                                                {/* User picture */}
                                                <div className="user-block-picture">
                                                    <div className="user-block-status">
                                                        <img
                                                            src={
                                                                user.image
                                                                    ? `data:image/png;base64, ${
                                                                          user.image
                                                                      }`
                                                                    : defaultUserAvatar
                                                            }
                                                            alt="Avatar"
                                                            className="img-thumbnail img-circle"
                                                        />
                                                        <div className="circle circle-success circle-lg" />
                                                    </div>
                                                </div>

                                                {/* Name and Job */}
                                                <div className="user-block-info">
                                                    <span className="user-block-name">
                                                        {user.firstName
                                                            ? user.firstName +
                                                              ' ' +
                                                              user.lastName
                                                            : ''}
                                                    </span>
                                                    <span className="user-block-role">
                                                        {user.roleName
                                                            ? user.roleName
                                                            : ''}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Collapse>
                            </li>
                            <div id="arkea-side-menu">
                                <SideMenu
                                    items={items}
                                    collapse={false}
                                    activeItem={activeItem}
                                    onMenuItemClick={value => {
                                        updateSidebarSelectedItem(value);
                                        if (value) {
                                            history.push(value);
                                        }
                                    }}
                                />
                            </div>
                        </ul>

                        {/* END sidebar nav */}
                    </nav>
                </div>
                {/* END Sidebar (left) */}
            </aside>
        );
    }
}

Sidebar.propTypes = {
    items: PropTypes.array.isRequired
};

Sidebar.defaultProps = {};

const mapStateToProps = state => ({
    user: state.authentication.user,
    sidebar: state.employee.sidebar
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ updateSidebarSelectedItem }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Sidebar));



// WEBPACK FOOTER //
// ./src/components/angle/Sidebar/index.js